import React from 'react';
import { RepType } from 'types';
import { Exercise } from '../Exercise';
import { ExerciseChip } from '../ExerciseChip';

export interface ChronicExerciseProps {
  uuid: string;
  name: string;
  anatomicalName?: string | null;
  pointsPerRep: number;
  reps: number;
  holdTime: number;
  thumbnailUrl?: string;
  repType?: RepType | null;
  substitutionText?: string;
}

export const ChronicExercise = ({
  uuid,
  name,
  anatomicalName,
  pointsPerRep,
  reps,
  holdTime,
  thumbnailUrl,
  repType,
  substitutionText
}: ChronicExerciseProps): JSX.Element => (
  <Exercise
    name={name}
    id={uuid}
    thumbnailUrl={thumbnailUrl}
    anatomicalName={anatomicalName}
    substitutionText={substitutionText}
  >
    <ExerciseChip label="pts/rep" value={pointsPerRep}></ExerciseChip>
    <ExerciseChip repType={repType} label="reps" value={reps}></ExerciseChip>
    <ExerciseChip label="sec hold" value={holdTime / 1000}></ExerciseChip>
  </Exercise>
);
